import { render, staticRenderFns } from "./PrintDelivery.vue?vue&type=template&id=b5cfc356&scoped=true"
import script from "./PrintDelivery.vue?vue&type=script&lang=js"
export * from "./PrintDelivery.vue?vue&type=script&lang=js"
import style0 from "./PrintDelivery.vue?vue&type=style&index=0&id=b5cfc356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cfc356",
  null
  
)

export default component.exports